import { ArrayUtils } from 'ts/commons/ArrayUtils';
import type { ExtendedStatementPathElement } from 'ts/perspectives/metrics/code/ExtendedStatementPathElement';
import styles from './RenderedCode.module.less';

type DataflowTracesProps = {
	traces: ExtendedStatementPathElement[];
};

/** Renders the traces of the dataflow statement path elements. */
export function DataflowTraces({ traces }: DataflowTracesProps) {
	return (
		<tr>
			<td colSpan={4} />
			<td className="flex">
				<div className={styles.dataflowStatementDescription} data-testid="dataflow-statement-description">
					{traces.map((trace: ExtendedStatementPathElement) => (
						<Trace key={trace.index} trace={trace} />
					))}
				</div>
			</td>
		</tr>
	);
}

type TraceProps = {
	trace: ExtendedStatementPathElement;
};

function Trace({ trace }: TraceProps) {
	return (
		<div
			title={
				ArrayUtils.isEmpty(trace.predecessors)
					? 'There are no predecessor nodes'
					: `Indices of predecessor nodes: ${trace.predecessors.join(', ')}`
			}
		>
			<span data-testid="trace-index" className={styles.number}>
				{trace.index}
			</span>
			<span data-testid="trace-description">{trace.description}</span>
		</div>
	);
}
